import { messageUtility } from '../../utilities/messageUtility';
import { extractErrorMessage } from '../../utilities/commonUtil';
import { DIALOG_STATUS } from '../../utilities/constants';
import _urlParamManager from '../../utilities/urlParamManager';
import EventManager, { EventType } from '../../utilities/EventManager';

/**
 * APIのレスポンスのパース
 * @param {*} data レスポンスのデータ
 * @returns {*} パースされたデータ
 */
const parseFetchInOutFieldAreasResponseData = data => {
  const result = data.entities.check_in_out_field_areas;
  return result;
};

/**
 * APIのエラーメッセージダイアログを表示する
 * @param {object} response レスポンスデータ
 * */
const showErrorMessageDialog = (state, response, dialogStatus=DIALOG_STATUS.otherErrorDialogEnabled.id) => {
  state.dialogStatus = dialogStatus;
  state.informationModal.title = null;
  state.informationModal.message = extractErrorMessage(response);
  state.informationModal.buttonText = messageUtility.getMessage('I-000-008');
  return state;
};

/**
 * ページをロードする
 * @param {React.ComponentClass} page ページコンポーネント
 * @param {object} props ページ状態
 * @param {string|int} id ページのオブジェクトID
 * */
const handleLoadPage = (page, pageNameString, props, id = false) => {
  const pageName = id ? `${pageNameString}:${id}` : pageNameString;
  _urlParamManager.setPage(pageName, props.vw);
  props.loadPage(page, [pageNameString, id]);
  setTimeout(() => {
    EventManager.trigger(EventType.LAYOUT_UPDATE, {});
  }, 1);
};

/**
 * エリア一覧画面で利用するビジネスロジック格納クラス
 * */
const InOutFieldAreasService = {
  parseFetchInOutFieldAreasResponseData,
  showErrorMessageDialog,
  handleLoadPage
};


export default InOutFieldAreasService;


// WEBPACK FOOTER //
// ./src/services/InOutFieldAreas/InOutFieldAreasService.js